import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateClient($companyId: ID!, $attributes: ClientAttributes!) {
    createClient(companyId: $companyId, attributes: $attributes) {
      client {
        id
        ...CreatedClient
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedClient on Client {
    id
    organisationName
    clientType { id name }
    phone
    email
    address1
    address2
    address3
    city
    county
    postcode
  }
`
